import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {
  BORDER_THICKNESS_RANGE,
  LAYOUT_BORDER_THICKNESS_RANGE,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-border-option/item-border.types';
import {BorderType} from '@PosterWhiteboard/classes/item-border.class';

interface BaseBorderThicknessOptionProps {
  solidBorderThickness: number;
  isForLayout?: boolean;
  updateThickness(solidBorderThickness: number, undoable?: boolean): void;
  className?: string;
  borderType: BorderType;
}

export function BaseBorderThicknessOption({className = '', isForLayout = false, ...props}: BaseBorderThicknessOptionProps): ReactElement<any> | null {
  const onChangeThicknessHandler = (value: number): void => {
    props.updateThickness(value, false);
  };

  const onChangeThicknessEnded = (value: number): void => {
    props.updateThickness(value, true);
  };

  return (
    <ContextualMenuSliderOptions
      className={className}
      id="item-border-thickness-option"
      value={props.solidBorderThickness}
      label={window.i18next.t('pmwjs_thickness')}
      range={isForLayout ? LAYOUT_BORDER_THICKNESS_RANGE : BORDER_THICKNESS_RANGE}
      transformDisplay={isForLayout ? LAYOUT_BORDER_THICKNESS_RANGE : BORDER_THICKNESS_RANGE}
      onChange={onChangeThicknessHandler}
      onChangeEnded={onChangeThicknessEnded}
      addDelayToOnChange={props.borderType === BorderType.STROKE_BORDER}
    />
  );
}
